export default {
  // Navbar
  'nav.home': 'Dịch Vụ Xuất Khẩu',
  'nav.choHem': 'Chợ Hẻm',
  'nav.investment': 'Dịch Vụ Định Cư',
  'nav.investment.main': 'Định Cư Latvia',
  'nav.investment.detail': 'Chi Tiết Định Cư Latvia',
  'nav.investment.partnership': 'Hợp Tác Kinh Doanh',
  'nav.investment.blog': 'Tin Tức & Blog',
  'nav.about': 'Về Chúng Tôi',
  'nav.contact': 'Liên Hệ',
  'nav.consult': 'Tư Vấn',

  // Footer
  'footer.about.title': 'Về The Daeg',
  'footer.about.desc': 'Chúng tôi là công ty hàng đầu trong lĩnh vực tư vấn định cư Latvia và phân phối sản phẩm Châu Á tại Châu Âu.',
  'footer.services.title': 'Dịch Vụ',
  'footer.services.investment': 'Định Cư Latvia',
  'footer.services.choHem': 'Chợ Hẻm',
  'footer.services.export': 'Xuất Khẩu Sang Châu Âu',
  'footer.services.partnership': 'Hợp Tác Kinh Doanh',
  'footer.contact.title': 'Liên Hệ',
  'footer.contact.address': 'Địa chỉ',
  'footer.contact.addressValue': 'Riga, Latvia',
  'footer.contact.phone': 'Điện thoại',
  'footer.contact.email': 'Email',
  'footer.contact.hours': 'Giờ làm việc',
  'footer.contact.hoursValue': 'Thứ 2 - Thứ 6: 9:00 - 18:00',
  'footer.follow.title': 'Theo Dõi Chúng Tôi',
  'footer.copyright': '© 2025 The Daeg International. Bản quyền thuộc về chúng tôi.',

  // Consult Modal
  'consult.title': 'Tư Vấn Miễn Phí',
  'consult.subtitle': 'Để lại thông tin, chuyên gia của chúng tôi sẽ liên hệ trong vòng 24 giờ',
  'consult.form.name': 'Họ và Tên',
  'consult.form.namePlaceholder': 'Nhập họ và tên của bạn',
  'consult.form.phone': 'Số Điện Thoại',
  'consult.form.phonePlaceholder': 'Nhập số điện thoại',
  'consult.form.email': 'Email',
  'consult.form.emailPlaceholder': 'Nhập email của bạn',
  'consult.form.service': 'Dịch Vụ Quan Tâm',
  'consult.form.servicePlaceholder': 'Chọn dịch vụ',
  'consult.form.serviceOptions.investment': 'Định Cư Đầu Tư Latvia',
  'consult.form.serviceOptions.choHem': 'Chợ Hẻm',
  'consult.form.serviceOptions.export': 'Xuất Khẩu Sang Châu Âu',
  'consult.form.serviceOptions.partnership': 'Hợp Tác Kinh Doanh',
  'consult.form.message': 'Nội Dung',
  'consult.form.messagePlaceholder': 'Cho chúng tôi biết nhu cầu của bạn...',
  'consult.form.submit': 'Gửi Yêu Cầu',
  'consult.form.submitting': 'Đang gửi...',
  'consult.success': 'Gửi yêu cầu thành công! Chúng tôi sẽ liên hệ với bạn sớm.',
  'consult.error': 'Có lỗi xảy ra. Vui lòng thử lại.',
};